import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
// import jwt from 'jwt-decode'
function LeftComp() {

  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
  const hr_permission = get_oermission_data.login_Permission.permissions
  // console.log('get_oermission_data===========================>get_oermission_data')
  // console.log(get_oermission_data.login_Permission.permissions)
  // console.log('get_oermission_data===========================>get_oermission_data')

  const [activemenu, setActivemenu] = useState("");
  const [showmenu, setShowmenu] = useState(false);
  const [showReprots, setShowReprots] = useState(false);
  const [showSkillMenu, setShowSkillMenu] = useState(false);
  var systemrole = localStorage.getItem("systemRole");
  //alert(systemrole)
  const location = useLocation();
  var string = location.search;
  useEffect(() => {

    let tmp = string.substring(1);
    if (tmp == "ems-policy") {
      setActivemenu(1);
      setShowmenu(true);
    } else if (tmp == "hsp") {
      setActivemenu(2);
      setShowmenu(true);
    } else if (tmp == "isms") {
      setActivemenu(3);
      setShowmenu(true);
    } else if (tmp == "qualitypolicy") {
      setActivemenu(4);
      setShowmenu(true);
    } else if (tmp == "codeofconduct") {
      setActivemenu(5);
      setShowmenu(true);
    } else if (tmp == "empmanual") {
      setActivemenu(6);
      setShowmenu(true);
    } else if (tmp == "groups") {
      setActivemenu(7);
      setShowSkillMenu(true);
    } else if (tmp == "manage") {
      setActivemenu(8);
      setShowSkillMenu(true);
    } else {
      setShowmenu(false);
      setShowSkillMenu(false);
      if (window.location.pathname == "/holidaylist") {
        setActivemenu(21);
      }
      if (window.location.pathname == "/momentsqbs") {
        setActivemenu(22);
      }
      if (window.location.pathname == "/feed-news") {
        setActivemenu(23);
      }
      if (window.location.pathname == "/resetpassword") {
        setActivemenu(24);
      }
      if (window.location.pathname == "/employeelist") {
        setActivemenu(25);
      }
      if (window.location.pathname == "/quotelist") {
        setActivemenu(26);
      }
      if (window.location.pathname == "/empattendance") {
        setActivemenu(27);
      }
      if (window.location.pathname == "/qbsconnecttalklist") {
        setActivemenu(28);
      }
      if (window.location.pathname == "/location") {
        setActivemenu(29);
      }
      if (window.location.pathname == "/policy") {
        setActivemenu(1);
        setShowmenu(true);
      }
      if (window.location.pathname == "/skills") {
        setActivemenu(6);
        setShowSkillMenu(true);
      }
      if (window.location.pathname == "/permission") {
        setActivemenu(30);
        setShowSkillMenu(true);
      }
      if (window.location.pathname == "/onboarding") {
        setActivemenu(31);
        setShowSkillMenu(true);
      }
      if (window.location.pathname == "/reports") {
        //setActivemenu(30);
        setShowReprots(true);
      }
    }
  }, [location]);

  // useEffect(()=>{ /empattendance
  // 	alert(showmenu)
  // },[])
  return (
    <div id="sidebar">
      <nav id="sidebarMenu" className="d-md-block sidebar">
        <div className="position-sticky">
          <ul className="nav flex-column">
            {
              (hr_permission?.includes('6') || systemrole == 2) && (
                <li className="nav-item">
                  <button
                    className="btn btn-toggle nav-link active align-items-center"
                    data-bs-toggle="collapse"
                    data-bs-target="#home-collapse"
                    aria-expanded="true">
                    Policy
                    <i className="icon icon-chevron-right"></i>
                  </button>
                  <div
                    className={`collapse submenu ${showmenu ? "show" : ""}`}
                    id="home-collapse"
                  >
                    {
                      (hr_permission?.includes('18') || hr_permission?.includes('19') || hr_permission?.includes('20') || hr_permission?.includes('21') || hr_permission?.includes('22') || hr_permission?.includes('23')) && (
                        <ul className="">
                          {(hr_permission?.includes('18')) && (<li>
                            <Link
                              className={` ${activemenu == 1 ? "active" : ""}`}
                              to="/policy?ems-policy"
                            >
                              - EMS Policy
                            </Link>
                          </li>)}
                          {(hr_permission?.includes('19')) && (<li>
                            <Link
                              className={` ${activemenu == 2 ? "active" : ""}`}
                              to="/policy?hsp"
                            >
                              - Health & Safety Policy
                            </Link>
                          </li>)}
                          {(hr_permission?.includes('20')) && (<li>
                            <Link
                              className={` ${activemenu == 3 ? "active" : ""}`}
                              to="/policy?isms"
                            >
                              - ISMS Policy Statement
                            </Link>
                          </li>)}
                          {(hr_permission?.includes('21')) && (<li>
                            <Link
                              className={` ${activemenu == 4 ? "active" : ""}`}
                              to="/policy?qualitypolicy"
                            >
                              - Quality Policy
                            </Link>
                          </li>)}
                          {(hr_permission?.includes('22')) && (<li>
                            <Link
                              className={` ${activemenu == 5 ? "active" : ""}`}
                              to="/policy?codeofconduct"
                            >
                              - Code Of Conduct
                            </Link>
                          </li>)}
                          {(hr_permission?.includes('23')) && (<li>
                            <Link
                              className={` ${activemenu == 6 ? "active" : ""}`}
                              to="/policy?empmanual"
                            >
                              - Employee Manual
                            </Link>
                          </li>)}
                        </ul>
                      )}
                  </div>
                </li>
              )
            }
            {
              (hr_permission?.includes('7') || hr_permission?.includes('24') || hr_permission?.includes('25')) && (
                <li className="nav-item">
                  <button
                    className="btn btn-toggle nav-link active align-items-center"
                    data-bs-toggle="collapse"
                    data-bs-target="#skill-collapse"
                    aria-expanded="true"
                  >
                    Skills
                    <i className="icon icon-chevron-right"></i>
                  </button>
                  <div
                    className={`collapse submenu ${showmenu ? "show" : ""}`}
                    id="skill-collapse"
                  >
                    {
                      (hr_permission?.includes('24') || hr_permission?.includes('25')) && (
                        <ul className="">
                          {
                            (hr_permission?.includes('24')) && (<li>
                              <Link
                                className={` ${activemenu == 6 ? "active" : ""}`}
                                to="/skills?groups"
                              >
                                Skill Set
                              </Link>
                            </li>
                            )}
                          {/* {
                            (hr_permission.includes('25')) && (
                          {
                            (hr_permission?.includes('25')) && (
                              <li>
                                <Link
                                  className={` ${activemenu == 7 ? "active" : ""}`}
                                  to="/skills?manage"
                                >
                                  Manage Skills
                                </Link>
                              </li>
                            )} */}
                             {/* <li>
                                <Link
                                  className={` ${activemenu == 7 ? "active" : ""}`}
                                  to="/skills?mapping"
                                >
                                  Mapping Skills
                                </Link>
                              </li> */}
                              <li>
                                <Link
                                  to="/skills?subSkill"
                                >
                                  Sub Skills
                                </Link>
                              </li>
                        </ul>
                      )
                    }
                  </div>
                </li>
              )
            }
            {(hr_permission?.includes('31') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 31 ? "active" : ""}`}
                  to="/onboarding"
                >
                  Onboarding Process
                </Link>
              </li>
            )}
            {(hr_permission?.includes('8') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 25 ? "active" : ""}`}
                  to="/employeelist"
                >
                  Employee List
                </Link>
              </li>
            )}
            {(hr_permission?.includes('9') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  to="/empattendance"
                  className={`nav-link ${activemenu == 27 ? "active" : ""}`}
                >
                  Leave Approval
                </Link>
              </li>
            )}

            {(hr_permission?.includes('10') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 24 ? "active" : ""}`}
                  to="/resetpassword"
                >
                  Reset Password
                </Link>
              </li>
            )}

            {(hr_permission?.includes('11') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 23 ? "active" : ""}`}
                  to="/feed-news"
                >
                  Feed News
                </Link>
              </li>
            )}

            {(hr_permission?.includes('12') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  to="/momentsqbs"
                  className={`nav-link ${activemenu == 22 ? "active" : ""}`}
                >
                  Moments at QBS
                </Link>
              </li>
            )}
            {(hr_permission?.includes('13') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  to="/quotelist"
                  className={`nav-link ${activemenu == 26 ? "active" : ""}`}
                >
                  Quote Of Day
                </Link>
              </li>
            )}

            {/* <li class="nav-item">
					<a class="nav-link" href="confirmationform.html">		
						Confirmation Form
					</a>
				</li> */}
            {(hr_permission?.includes('14') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 21 ? "active" : ""}`}
                  to="/holidaylist"
                >
                  List of Holidays
                </Link>
              </li>
            )}
            {(hr_permission?.includes('15') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 28 ? "active" : ""}`}
                  to="/qbsconnecttalklist"
                >
                  List QBS Connect Talk
                </Link>
              </li>
            )}
            {(hr_permission?.includes('16') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 29 ? "active" : ""}`}
                  to="/location"
                >
                  Location
                </Link>
              </li>
            )}

            {(hr_permission?.includes('17') || systemrole == 2) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 30 ? "active" : ""}`}
                  to="/permission"
                >
                  User Permission
                </Link>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default LeftComp;
